import { render, staticRenderFns } from "./applySign.vue?vue&type=template&id=2d87c752&scoped=true&"
import script from "./applySign.vue?vue&type=script&lang=ts&"
export * from "./applySign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d87c752",
  null
  
)

export default component.exports